/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_1Inputs */

const vi_irrigation_weekday_1 = /** @type {(inputs: Irrigation_Weekday_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T2`)
};

/**

* @param {Irrigation_Weekday_1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_1 = /** @type {((inputs?: Irrigation_Weekday_1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_1(inputs)
});